export class FeedbackPlaceholderComponent {
    private feedbackInputItems: HTMLInputElement[] ;

    constructor(
        private container: HTMLElement
    ) {
        this.feedbackInputItems = Array.prototype.slice.call(
            this.container.querySelectorAll('[data-feedback-input]')
        );
    }
    public initialize(): void {
        this.feedbackInputItems.forEach((feedbackInputItem: HTMLInputElement) => {
            feedbackInputItem.addEventListener('input', (e) => {
                feedbackInputItem.value
                    ? feedbackInputItem.classList.add('invisible-placeholder')
                    : feedbackInputItem.classList.remove('invisible-placeholder');
            });
        })
    }
}
